import type { App } from 'vue';
import { permission } from './core/permission';

/**
 * 注册所有全局指令
 */
export function setupDirectives(app: App) {
  // 注册按钮权限指令
  app.directive('hasPermission', permission);
}
